import ProductsCategoryFilter from '@/components/products/ProductsCategoryFilter/index.vue';

export default {
  name: 'ProductsSidebarFilters',
  components: {
    ProductsCategoryFilter
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  emits: [],
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
  unmounted() {}
};
